<div fxFlex="row" fxLayoutAlign="start center" class="header">
    <div fxFlex="row" fxLayoutAlign="start center">
        <div
            class="container-img"
            [ngClass]="{
                'container-img': !getMatSidenav,
                'container-img-open': getMatSidenav
            }"
        >
            <div
                [ngClass]="{
                    'show-logo': !getMatSidenav,
                    'not-show-logo': getMatSidenav
                }"
            >
                <img
                    src="../../../assets/img/mb-icon/mb.png"
                    *ngIf="!getMatSidenav"
                />
            </div>
            <div
                [ngClass]="{
                    'show-logo': getMatSidenav,
                    'not-show-logo': !getMatSidenav
                }"
            >
                <img
                    src="../../../assets/img/mb-icon/monte.svg"
                    *ngIf="getMatSidenav"
                    style="width: 150px"
                />
            </div>
        </div>
    </div>

    <mb-button
        variant="stroked"
        size="md"
        color="primary"
        icon="arrow-after"
        (click)="logout()"
        iconPosition="right"
        class="btn-right-menu"
    >
        Sair
    </mb-button>
</div>
